<template>
    <a-file-window ref="aFileWindow" :pageWidth="afilePageWidth" :pageHeight="afilePageHeight"
        :AFileConfig="AFileConfig" @onChangeSize="resizeAfile" @pointerdown="focusWindow()">
        <img ref="afileImage" class="afile-image" :src="getImageSrc">
        <template v-slot:toolbar>
            <change-image-bar @nextImage="handleNextImage" @prevImage="handlePrevImage" @changeImage="handleChangeImage"
                :images="getImageOptions" :nowIndex="getNowIndex" />
        </template>
    </a-file-window>
</template>

<script>
import ChangeImageBar from './ChangeImageBar.vue'
import AFileWindow from './AFileWindow.vue'
import BookData from '../../js/book_data'
import { focusStore } from '@/js/store/nowFocusStore'
import PainterProxy from '@/js/painter/proxy'
export default {
    name: "AFileChangeImage",
    components: {
        ChangeImageBar,
        AFileWindow
    },
    data: function () {
        return {
            baseUrl: "D:/projects/books/",
            nowImage: 0,
            totalImageCount: 8,
            afilePageWidth: 1856,
            afilePageHeight: 856,
        }
    },
    props: [
        "AFileConfig"
    ],
    methods: {
        resizeAfile: function (width, height) {
            this.afilePageWidth = width - 64;
            this.afilePageHeight = height - 80;
        },
        handleNextImage() {
            this.nowImage++;

            if (this.nowImage > this.totalImageCount - 1) {
                this.nowImage = 0;
            }
        },
        handlePrevImage() {
            this.nowImage--;
            if (this.nowImage < 0) {
                this.nowImage = this.totalImageCount - 1;
            }
        },
        handleChangeImage(index) {
            let groupIndex = Math.floor(this.nowImage / 6)
            this.nowImage = groupIndex * 6 + index;
        },
        focusWindow() {
            this.$refs.aFileWindow.setFocusPainter();
            setTimeout(() => {
                focusStore.setNowPageItemControl({}, this.AFileConfig.type);
            })
        }
    },
    computed: {
        getImageSrc: function () {
            let index = this.nowImage % 6;
            if(this.$refs.afileImage) {
                PainterProxy.getInstance().clearAll();
            }
            return `${BookData.Instance.getBookPicturePath()}${this.AFileConfig.fileName}/${this.getImageOptions[index]}.png`;
        },
        getImageOptions: function () {
            let groupIndex = Math.floor(this.nowImage / 6);
            let i = 0;
            let options = [];
            let optionCount = this.totalImageCount - (groupIndex * 6) > 6 ? 6 : this.totalImageCount - (groupIndex * 6);
            for (i = 0; i < optionCount; i++) {
                options.push((groupIndex * 6 + i + 1).toString());
            }

            return options;
        },
        getNowIndex: function () {
            return this.nowImage % 6
        }
    },
    created: function () {

    },
    mounted: function () {
        this.totalImageCount = this.AFileConfig.total;

        this.focusWindow();
    }
}
</script>

<style scoped>
.afile-image {
    position: absolute;
    /* width: calc(100% - 64px);
    height: calc(100% - 80px); */
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
}
</style>